module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/0ecc324aaf52d542f097aa2edfbf30f1.png";